import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import type { Citation } from '@/store/conversation';

interface SJChatCitationsProps {
  citations: Citation[];
}

const ENTITY_ROUTE_MAP: Record<string, string> = {
  knowledge: '/knowledge',
  workflow: '/workflows',
  industry: '/industries',
  goal: '/goals',
  product: '/products',
  problem: '/knowledge',
};

const ENTITY_LABEL_MAP: Record<string, string> = {
  knowledge: 'Article',
  workflow: 'Workflow',
  industry: 'Industry',
  goal: 'Goal',
  product: 'Product',
  problem: 'Problem',
};

export function SJChatCitations({ citations }: SJChatCitationsProps) {
  if (!citations.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      className="mt-3 space-y-1.5"
    >
      <p className="text-[11px] font-medium uppercase tracking-wider text-[var(--sj-text-muted)]">
        Referenced Knowledge
      </p>
      <div className="flex flex-wrap gap-2">
        {citations.map((citation, i) => (
          <Link
            key={i}
            to={`${ENTITY_ROUTE_MAP[citation.entityType] || '/knowledge'}/${citation.slug}`}
            className="group flex items-center gap-1.5 rounded-[8px] border border-[var(--sj-border)] bg-[var(--sj-surface)] px-2.5 py-1.5 text-xs transition-all hover:border-primary-300 hover:bg-primary-50 dark:hover:bg-primary-950/20"
          >
            <span className="rounded bg-[var(--sj-surface-muted)] px-1 py-0.5 text-[10px] font-medium text-[var(--sj-text-muted)]">
              {ENTITY_LABEL_MAP[citation.entityType] || 'Article'}
            </span>
            <span className="text-[var(--sj-text-secondary)] group-hover:text-primary-700 dark:group-hover:text-primary-300">
              {citation.title}
            </span>
            <ArrowRight className="h-3 w-3 text-[var(--sj-text-muted)] group-hover:text-primary-500" />
          </Link>
        ))}
      </div>
    </motion.div>
  );
}
